import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
export const NAMESPACE = "settings";
export const FULL_NAMESPACE = createNamespace(NAMESPACE);
